import styled from "styled-components";
import HeroLandingPage from "../../assets/icons/hero-landingPage.png";
import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";

export const LoginContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
`;

export const HeroBackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url("/assets/icons/hero-landingPage.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  img {
    width: 100%;
    height: 100vh;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
`;

export const HeaderContainer = styled.div`
  position: absolute;
  top: 3%;
  left: 6%;

  img {
    width: 100%;
    height: auto;
    cursor: pointer;
  }
`;

export const LoginGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: absolute;
  top: 10%;
  height: 89%;
  width: 100%;
  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const LoginForm = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 10px;
  width: 100%;
  height: fit-content;
`;

export const LoginImage = styled.div`
  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const LoginModalContainer = styled.div`
  background-color: white;
  // padding: 50px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 67%;
  padding: 40px 20px 40px 10px;

  // @media screen and (max-width: 1024px) and (max-height: 912px) {
  //   width: 80%;
  //   height: 80%;
  //   padding: 20px;
  // }

  @media screen and (max-width: 1024px) {
    width: 70%;
    padding: 40px;
    margin-top: 40px;
  }

  @media screen and (max-width: 1024px) and (max-height: 912px) {
    width: 80%;
    padding: 20px;
  }

  @media screen and (max-width: 1024px) and (max-height: 600px) {
    width: 70%;
    padding: 40px;
    margin-top: 30px;
  }

  @media screen and (max-width: 820px) {
    width: 70%;
    padding: 40px;
    margin-top: 40px;
  }

  @media screen and (max-width: 768px) {
    width: 70%;
    padding: 40px;
    margin-top: 40px;
  }

  @media screen and (max-width: 540px) {
    width: 60%;
    padding: 30px;
    margin-top: 40px;
  }

  @media screen and (max-width: 430px) {
    width: 60%;
    padding: 40px;
    margin-top: 40px;
  }

  @media screen and (max-width: 414px) {
    width: 60%;
    padding: 40px;
    margin-top: 40px;
  }
  @media screen and (max-width: 375px) {
    width: 65%;
    padding: 30px;
  }

  @media screen and (max-width: 360px) {
    width: 65%;
    padding: 30px;
    // margin-top: 40px;
  }

  @media screen and (max-width: 412px) and (max-height: 915px) {
    width: 75%;
    padding: 40px 20px 40px 10px;
  }
`;

export const LoginInformation = styled.div`
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.fontSize.heading2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.NAVYBLUE};
  font-family: "Gt Walsheim Pro", sans-serif;

  @media screen and (max-width: 375px) {
    //styleName: Web/Body/P1/Bold;
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body1};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: 32px;
    letter-spacing: 0.02em;
  }
`;

export const LoginAccountText = styled.div`
  text-align: center;
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  margin-top: 15px;
  color: ${colors.DARK_GRAY};
  // line-height: 24px;
  @media screen and (max-width: 900px) {
    margin-top: 10px;
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    line-height: 24px;
    letter-spacing: 0.02em;
    text-align: center;
  }
`;

export const InputContainer = styled.div`
  padding-top: 30px;

  // @media screen and (max-width: 412px) and (max-height: 915px) {
  //   width: 110%;
  //   padding-right: 20px;
  //   letter-spacing: 0.1px;
  //   border: 2px solid red;
  // }
`;

export const ImageCard = styled.img``;

export const ForgotPasswordContainer = styled.div`
  padding-left: 20px;
`;

export const ForgotPasswordText = styled.h3`
  font-family: "GT Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  text-align: left;
  color: #00a603;
  cursor: pointer;
`;

export const LoginButtonContainer = styled.div`
  padding-top: 30px;
  padding-left: 20px;
  width: 100%;
  @media screen and (max-width: 1024px) {
    width: 100%;
    margin: 0 auto;
  }
  @media screen and (max-width: 1024px) {
    padding-left: 0px;
  }
  @media screen and (max-width: 768px) {
    padding-left: 0px;
  }
  @media screen and (max-width: 412px) {
    display: flex;
    justify-content: center;
    padding-left: 5px;
    // border: 2px solid red;
  }
  @media screen and (max-width: 390px) {
    display: flex;
    justify-content: center;
    padding-left: 5px;
    // border: 2px solid red;
  }
`;

export const CreateAccountContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
`;

export const CreateAccountText = styled.span`
  font-family: "GT Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  text-align: left;
  color: #5e5e5e;

  @media screen and (max-width: 900px) {
    //styleName: Web/Body/P3/Regular;
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    line-height: 24px;
    letter-spacing: 0.02em;
    text-align: left;
  }

  @media screen and (max-width: 412px) and (max-height: 915px) {
    width: 80%;
    font-size: 11px;
    letter-spacing: 0.1px;
  }
`;

export const SubText = styled.span`
  color: #5cb227;
  cursor: pointer;
  font-family: "GT Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  text-align: left;
  padding-left: 4px;

  @media screen and (max-width: 412px) and (max-height: 915px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  }
`;
